/**
 * localStorage key for tenant subdomain (first host label), sent as `subdomain_name`
 * on Auth0 → API token exchange when present.
 */
export const SUBDOMAIN_NAME_STORAGE_KEY = "ann_subdomain_name";
